import { render, staticRenderFns } from "./TransferView.vue?vue&type=template&id=0b29cfc0&scoped=true"
import script from "./TransferView.vue?vue&type=script&lang=js"
export * from "./TransferView.vue?vue&type=script&lang=js"
import style0 from "./TransferView.vue?vue&type=style&index=0&id=0b29cfc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29cfc0",
  null
  
)

export default component.exports